import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataListTag, DataListTagGroup } from "../../models/data-list";

@Component({
    selector: "app-tag-picker",
    templateUrl: "./tag-picker.component.html",
    styleUrls: ["./tag-picker.component.scss"],
    standalone: false
})
export class TagPickerComponent implements OnInit {
  @Input("available-tags") availableTagGroups: DataListTagGroup[] = [];
  @Input("preselected-tag-ids") preselectedTagIds: string[] = [];
  @Output() selectedTagCountChanged = new EventEmitter<number>();

  selectedTags: DataListTag[][] = [];

  constructor() {}

  ngOnInit(): void {
    this.availableTagGroups.forEach((g) =>
      this.selectedTags.push(
        g.tags.filter((t) => this.preselectedTagIds.includes(t.id))
      )
    );
  }

  public getSelectedCount(index: number) {
    if (this.selectedTags.length > index) {
      return this.selectedTags[index].length;
    }
    return 0;
  }

  public getSelectedTagIds() {
    const selected: DataListTag[] = [];
    this.selectedTags.forEach((r) => r.forEach((c) => selected.push(c)));
    return selected.map((m) => m.id);
  }

  tagChanged() {
    const selectedCount = this.selectedTags.reduce(
      (count, row) => count + row.length,
      0
    );
    this.selectedTagCountChanged.emit(selectedCount);
  }
}
